import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
export default function useIsLoading() {
  const {
    loading
  } = usePreviewData();
  return loading;
}